import {
  Directive,
  EventEmitter,
  Output,
  Input,
  HostBinding,
  ElementRef,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[appDragDropFileUpload]',
  standalone: false,
})
export class DragDropFileUploadDirective implements OnInit, OnDestroy {
  @Input() disabled: boolean = false;
  @Output() fileDropped: EventEmitter<FileList> = new EventEmitter<FileList>();
  @HostBinding('style.background-color') background: string = '#f9f9f9';
  @HostBinding('style.cursor') get cursor() { return this.disabled ? 'not-allowed' : 'pointer'; }
  @HostBinding('style.opacity') get opacity() { return this.disabled ? '0.5' : '1'; }

  private subscriptions: Subscription[] = [];

  private readonly el: ElementRef = inject(ElementRef);

  ngOnInit(): void {
    const dragOverSubscription: Subscription = fromEvent<DragEvent>(this.el.nativeElement, 'dragover').subscribe(event => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.disabled) {
        this.background = '#e6e6e6';
      }
    });

    const dragLeaveSubscription: Subscription = fromEvent<DragEvent>(this.el.nativeElement, 'dragleave').subscribe(event => {
      event.preventDefault();
      event.stopPropagation();
      this.background = '#f9f9f9';
    });

    const dropSubscription: Subscription = fromEvent<DragEvent>(this.el.nativeElement, 'drop').subscribe(event => {
      event.preventDefault();
      event.stopPropagation();
      this.background = '#f9f9f9';
      if (!this.disabled) {
        const files: FileList | undefined = event.dataTransfer?.files;
        if (files && files.length > 0) {
          this.fileDropped.emit(files);
        }
      }
    });

    const clickSubscription: Subscription = fromEvent<MouseEvent>(this.el.nativeElement, 'click').subscribe(event => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.disabled) {
        const inputElement: HTMLInputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.click();
        inputElement.addEventListener('change', (fileChangeEvent: Event) => {
          const target: HTMLInputElement = fileChangeEvent.target as HTMLInputElement;
          const files: FileList | null = target.files;
          if (files?.length) {
            this.fileDropped.emit(files);
          }
        });
      }
    });

    this.subscriptions.push(dragOverSubscription, dragLeaveSubscription, dropSubscription, clickSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
